import parseHTML from 'html-react-parser';
import { PROPS_TO_CHECK } from '../constants';

const parseImageData = (image, index, priorityLimit, shouldDisplayCaption) => {
  const { data = {} } = image;
  const parsedData = {};

  PROPS_TO_CHECK.forEach(dataKey => {
    const value = data && data[dataKey];
    if (dataKey === 'caption') {
      parsedData[dataKey] = shouldDisplayCaption && !!value ? parseHTML(value) : '';
      return;
    }
    parsedData[dataKey] = value || '';
  });

  return {
    ...parsedData,
    id: image.id,
    url: image.url,
    priority: index < priorityLimit
  };
};

export default parseImageData;
